import * as React from "react";
import { useCallback } from "react";
import StoreContainer from "../stores/StoreContainer";
import VisitorStore from "../stores/VisitorStore";
import { Form, FormField } from "../types";

interface ChatFormProps {
  form: Form;
  onSubmit(data: any): void;
}

export default function ChatForm(props: ChatFormProps) {
  const initializeData = useCallback(() => {
    const data: any = {};

    const visitorName = StoreContainer.VisitorStore.getVisitorName();
    const visitorEmail = StoreContainer.VisitorStore.getVisitorEmail();
    const visitorPhone = StoreContainer.VisitorStore.getVisitorPhone();
    const customData = StoreContainer.SettingStore.getCustomVars();

    for (const field of props.form.fields) {
      const dataName = field.dataField.name;

      if (dataName === "Name") {
        data["Name"] = visitorName;
        continue;
      }

      if (dataName === "Email") {
        data["Email"] = visitorEmail;
        continue;
      }

      if (dataName === "Phone") {
        data["Phone"] = visitorPhone;
        continue;
      }

      data[dataName] = customData[dataName];
    }

    return data;
  }, [props.form.fields]);

  const [data, setData] = React.useState<any>(initializeData());

  const onChange = useCallback(
    (field: FormField, newValue: any) => {
      const clone = { ...data };
      clone[field.dataField.name] = newValue;
      setData(clone);
    },
    [data]
  );

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      props.onSubmit(data);
    },
    [data, props]
  );

  return (
    <div className="velaro-form-container">
      <form className="velaro-form" onSubmit={onSubmit}>
        {props.form.fields.map((field, i) => (
          <ChatFormField
            key={i}
            field={field}
            value={data[field.dataField.name]}
            onChange={(newValue) => onChange(field, newValue)}
          />
        ))}
        <button className="velaro-btn primary velaro-pull-right" type="submit">
          Submit
        </button>
      </form>
    </div>
  );
}

interface ChatFormFieldProps {
  field: FormField;
  value: any;
  onChange(value: any): void;
}

function ChatFormField({ field, value, onChange }: ChatFormFieldProps) {
  const renderInput = useCallback(() => {
    switch (field.dataField.format) {
      case "Text":
        return (
          <input
            type="text"
            value={value || ""}
            required
            placeholder={field.placeholder}
            onChange={(e) => onChange(e.currentTarget.value)}
          />
        );
      case "Number":
        return (
          <input
            type="number"
            value={value || ""}
            required
            placeholder={field.placeholder}
            onChange={(e) => onChange(e.currentTarget.valueAsNumber)}
          />
        );
      case "Email":
        return (
          <input
            type="email"
            value={value || ""}
            required
            placeholder={field.placeholder}
            onChange={(e) => onChange(e.currentTarget.value)}
          />
        );
      case "MultilineText":
        return (
          <textarea
            value={value || ""}
            required
            placeholder={field.placeholder}
            onChange={(e) => onChange(e.currentTarget.value)}
          />
        );
      default:
        console.error(`unhandled datafield format: ${field.dataField.format}`);
        return;
    }
  }, [field, onChange, value]);

  return (
    <div className="velaro-form-group">
      <label>{field.label || field.dataField.name}</label>
      {renderInput()}
    </div>
  );
}
